import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MasterApi,
  UpdateMasterRequestBody,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

export const useMutationUpdateMaster = (masterUuid: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: UpdateMasterRequestBody) => {
      return await baseClient
        .getApi(MasterApi)
        .updateMaster({ masterUuid, updateMasterRequestBody: request })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.masters })
      queryClient.invalidateQueries({ queryKey: queryKeys.master(masterUuid) })
    },
  })
}
